import React from 'react';
import {IconListFragment} from '@graphql-types';
import {graphql} from 'gatsby';

import * as styles from './iconList.module.scss';
import PageSection from '@src/components/PageSection';

const IconList = (props: IconListFragment) => {
  return (
    <PageSection>
      <div className={styles.section}>
        <h2 className={styles.header}>{props.primary.heading.text}</h2>
        <ul className={styles.columnContainer}>
          {props.items.map((item: any, idx: any) => (
            <li key={idx} className={styles.column}>
              <figure className={styles.figure}>
                <img
                  className={styles.art}
                  src={item.icon.url}
                  alt=""
                  role="presentation"
                />
              </figure>
              <div>
                <p className={styles.subhead}>{item.icon_heading.text}</p>
                <div
                  className={styles.desc}
                  dangerouslySetInnerHTML={{__html: item.description.html}}
                />
              </div>
            </li>
          ))}
        </ul>
      </div>
    </PageSection>
  );
};

export default IconList;

export const query = graphql`
  fragment iconList on PrismicPageDataBodyIconList {
    id
    slice_type
    primary {
      heading {
        text
      }
    }
    items {
      icon {
        url
      }
      icon_heading {
        text
      }
      description {
        html
      }
      link {
        url
      }
    }
  }
`;
